/**
 * "Mark all" / "clear all": a single bulk request instead of one PUT per
 * notification id. Changelog entries are client-side synthetic
 * notifications (not rows in the `notifications` table the bulk endpoint
 * covers), so they still get their own markChangelogSeen call - but that
 * never turns into per-notification traffic for the real notifications.
 *
 * On any failure the local inbox is left untouched (no mark, no remove) -
 * the error simply propagates so the caller's existing catch/log/retry
 * behavior applies.
 */
export const markAllNotificationsRead = async ({
  notifications,
  axiosPrivate,
  markAllNotificationsAsReadRequest,
  markChangelogSeen,
  applyLocalUpdate,
}) => {
  const changelogNotifications = (notifications || []).filter((n) => n?.data?.isChangelog);

  await Promise.all(
    changelogNotifications.map((n) =>
      markChangelogSeen(n.data.latestId, axiosPrivate).catch((err) => console.log("err", err))
    )
  );

  await markAllNotificationsAsReadRequest(axiosPrivate);

  applyLocalUpdate();
};
